import IpBlacklistsGrid from '../components/Grid';
import { IpBlacklistProvider } from '../store';

export default function IpBlacklistsGridLayout() {
  return <IpBlacklistProvider>
    <IpBlacklistsGrid />
  </IpBlacklistProvider>;
}
